import { render, staticRenderFns } from "./popupPrompt.vue?vue&type=template&id=2dfa85ce&scoped=true&"
import script from "./popupPrompt.vue?vue&type=script&lang=js&"
export * from "./popupPrompt.vue?vue&type=script&lang=js&"
import style0 from "./popupPrompt.vue?vue&type=style&index=0&id=2dfa85ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa85ce",
  null
  
)

export default component.exports